import RoutingActions from '../../actions/RoutingActions';
import PopupActions from '../../actions/PopupActions';
import GuestListActions from '../../actions/GuestListActions';

import GuestListStore from '../../stores/GuestListStore';

import GLSearchResult from './GLSearchResult.react';

class GLSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchResults : false
        };

        this.onGuestListSearchChange = this.onGuestListSearchChange.bind(this);
    }

    componentDidMount() {
        GuestListStore.addSearchListener(this.onGuestListSearchChange);
    }

    componentWillUnmount() {
        GuestListStore.removeChangeListener(this.onGuestListSearchChange);
    }

    onGuestListSearchChange() {
        var self = this;
        // var result = GuestListStore.getState().searchResults;

        // if (result.length === 1) {
        //     if (result[0].MJStateIDNo === $('#gl-header-search').val()) {
        //         GuestListActions.checkGuestIn(result[0]);
        //         $('#gl-header-search').val()
        //     }
        // }
        this.setState({
            searchResults : GuestListStore.getState().searchResults
        });
    }

    render() {
        var page = this.props.page;

        if (page !== 'search')
        	return null;

        var searchResults = this.state.searchResults ? this.state.searchResults : [];

        return (
            <div className='gl-search'>
                { searchResults.map((guest, i) => {
                    return (
                        <GLSearchResult
                            guest={guest}
                            key={'gl-search-'+guest.Guest_id} />
                    );
                })}
            </div>
        );
    }
}

export default GLSearch;

/*



*/


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLSearch.react.jsx